export const computeCountriesPctValue = (value: number, total: number): string => ((value / total) * 100).toFixed(2);
